<template>
  <v-dialog
    :value="$store.state.purchase.show"
    fullscreen
    scrollable
    persistent
    no-click-animation
  >
    <v-card color="secondary">
      <v-toolbar
        flat
        dark
        color="accent"
        height="36"
        max-height="36"
      >
        <v-spacer />
        <v-btn
          icon
          small
          color="primary"
          @click="$store.dispatch('purchase/close')"
        >
          <v-icon small v-text="icons.close" />
        </v-btn>
      </v-toolbar>
      <v-card-text class="white--text px-0 pb-16">
        <h-purchase-intro />
        <h-purchase-cta />
        <h-purchase-steps />
        <h-purchase-faq />
        <h-purchase-cta />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'
  import HPurchaseIntro from './Contents/Intro'
  import HPurchaseSteps from './Contents/Steps'
  import HPurchaseFaq from './Contents/Faq'
  import HPurchaseCta from './Contents/Cta'

  export default {
    mixins: [
      UsesIcons,
    ],

    components: {
      HPurchaseIntro,
      HPurchaseSteps,
      HPurchaseFaq,
      HPurchaseCta,
    },
  }
</script>
